import React from "react";
import { LuRadio } from "react-icons/lu";

export default function CheckersStatusBar({
  currentTurn,
  myPiece,
  winner,
  isCompleted,
  p1Name = "Red",
  p2Name = "Blue",
  wsStatus,
  isAI = false,
  maxWidthStyle,
}) {
  const turnName = currentTurn === 1 ? p1Name : p2Name;
  const winnerName = winner === 1 ? p1Name : winner === 2 ? p2Name : null;
  const text = isCompleted
    ? winnerName ? `${winnerName} wins` : "Draw"
    : myPiece === currentTurn ? "Your turn" : `${turnName}'s turn`;

  return (
    <div
      className="
        w-full mx-auto mb-2 min-h-[78px]
        [@media(min-width:768px)_and_(max-height:700px)]:min-h-[68px]
        [@media(min-width:768px)_and_(max-height:700px)]:mb-1.5
      "
      style={{ maxWidth: maxWidthStyle || "min(88vw, 640px)" }}
    >
      <div className="flex h-8 items-center justify-between gap-2 overflow-hidden">
        <div className="flex min-w-0 items-center gap-2 overflow-hidden">
          <span className="inline-flex h-8 items-center rounded-full border border-border-soft bg-slate-950/45 px-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-text-muted">
            {isAI ? "vs AI" : "Multiplayer"}
          </span>
          <span className="inline-flex h-8 min-w-0 items-center gap-2 rounded-full border border-border-soft bg-slate-950/45 px-3 text-[10px] font-semibold uppercase tracking-[0.16em] text-text-secondary">
            <PieceDot piece={myPiece} />
            <span className="truncate">You are {myPiece === 1 ? "Red" : "Blue"}</span>
          </span>
        </div>
        {wsStatus ? (
          <span className="inline-flex h-8 items-center gap-1.5 rounded-full border border-brand-cyan/20 bg-brand-cyan/10 px-3 text-[10px] font-semibold uppercase tracking-[0.08em] text-brand-cyan">
            <LuRadio size={11} />
            {wsStatus === "connected" ? "Live" : wsStatus}
          </span>
        ) : null}
      </div>

      <div className="mt-2 flex h-10 min-w-0 items-center justify-between gap-2 [@media(min-width:768px)_and_(max-height:700px)]:mt-1.5">
        <div className="flex h-10 min-w-0 flex-1 items-center rounded-2xl border border-black/60 bg-[linear-gradient(145deg,#0b1117,#030607)] px-3 shadow-[inset_0_1px_0_rgba(255,255,255,0.055),0_10px_24px_rgba(0,0,0,0.28)]">
          <div className="truncate font-display text-sm font-semibold tracking-tight text-text-primary sm:text-base">
            {text}
          </div>
        </div>
        {!isCompleted ? (
          <div className="hidden h-10 rounded-2xl border border-border-soft bg-slate-950/45 px-3 py-1.5 text-right sm:block">
            <div className="text-[9px] font-semibold uppercase tracking-[0.16em] text-text-faint">Turn</div>
            <div className="font-mono text-xs font-semibold text-text-primary">
              {currentTurn === 1 ? "Red" : "Blue"}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

function PieceDot({ piece }) {
  const isRed = piece === 1;
  return (
    <span
      className="h-3 w-3 rounded-full border shadow-[0_0_18px_rgba(0,0,0,0.25)]"
      style={{
        borderColor: isRed ? "rgba(251,113,133,0.75)" : "rgba(96,165,250,0.75)",
        background: isRed
          ? "linear-gradient(145deg,#fb7185,#be123c)"
          : "linear-gradient(145deg,#60a5fa,#1d4ed8)",
      }}
      aria-hidden="true"
    />
  );
}
